import styled from "styled-components";

export const Container = styled.div``;
export const Top = styled.div`
  display: flex;
  justify-content flex-start;
`;
export const Title = styled.p`
  font-weight: 400;
  font-size: 60px;
  line-height: 100px;
  letter-spacing: 0.3em;
  margin-bottom: 30px;
  @media screen and (max-width: 480px) {
    font-size: 35px;
    line-height: 70px;
    margin-bottom: 15px;
    padding-left: 5px;
  }
`;
export const Bottom = styled.div``;
export const Section1 = styled.div`
  width: 100%;
  display: flex;
  justify-content flex-start;
  margin-bottom:60px;
  @media screen and (max-width: 480px) {
    margin-bottom: 20px;
    justify-content center;
  }
`;
export const Section2 = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 60px;
  @media screen and (max-width: 480px) {
    margin-bottom: 20px;
    justify-content center;
  }
`;
